<template>
  <div>
    <b-form-group class="lato-regular field-headings" :label="labelName">
      <b-input-group :prepend="isdCode" class="width-control-small lato-regular-input">
        <b-form-input
          :name="errorMessage"
          :id="labelName"
          :value="defaultValue"
          v-validate="validation"
          :state="errors.has(errorMessage) ? false : null"
          @input="inputText($event)"
          class="width-control-small lato-regular-input m-0"
          :disabled="disabled"
        ></b-form-input>
      </b-input-group>
      <div
        :class="'helo-block alert alert-danger errorWidthSmall mt-1'"
        v-show="errors.has(errorMessage)"
      >{{errors.first(errorMessage)}}</div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  components: {},
  props: [
    "labelName",
    "validation",
    "inputAdditions",
    "isdCode",
    "className",
    "disabled",
    "defaultValue",
    "errorMessage"
  ],
  data() {
    return {};
  },
  methods: {
    inputText(event) {
      console.log("A", event);
      this.$emit("textInputChange", event);
      // if (event) {
      //   console.log("B", event);
      //   this.$emit("textInputChange", event);
      // }
    }
  }
};
</script>
<style scoped>
.errorWidth {
  font-size: 12px !important;
  width: 50% !important;
  padding: 2px !important;
}
.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
.bold {
  font-weight: bold !important;
}
</style>